import { http } from '@/http';

export type OnboardingData = {
	phone_code: string;
	phone_number: string;
	address: string;
	cert_type: string;
	document_type: 'DPI' | 'PASSPORT';
	document_number: string;
	additional_data: {
		legalRepInfo: {
			company_name: string;
			company_tax_id: string;
			company_address: string;
			representation_capacity: string;
		};
		professionalInfo: {
			license_number: string;
			professional_association: string;
		};
		employeeInfo: {
			company_name: string;
			company_department: string;
			company_address: string;
			company_tax_id: string;
			job_role: string;
		};
		companyInfo: {
			company_name: string;
			company_department: string;
			company_address: string;
			company_tax_id: string;
		};
		publicOfficialInfo: {
			organization_name: string;
			organization_address: string;
			organization_phone: string;
			position: string;
		};
	};
};

export type OnboardingResponse = {
	NextStep: string;
	Address: string;
	BirthDate: string;
	DPI: string;
	DocumentDateOfExpiration: string;
	DocumentIssueDate: string;
	DocumentIssuingCountry: string;
	Email: string;
	FirstName: string;
	FullName: string;
	Gender: string;
	LastName: string;
	NIT: string;
	Nationality: string;
	OnboardingProcessUlid: string;
	PhoneCountryCode: string;
	PhoneNumber: string;
	Profession: string;
};

export const dataEnrichment = async (
	onboardingUlid: string,
	onboardingData: OnboardingData,
) => {
	return http.post<OnboardingResponse>(
		`v2/onboarding/${onboardingUlid}/data-enrichment`,
		onboardingData,
	);
};
